export const CONTACT_FORM_NAME = 'resolution-flow-contact-form'
